module.exports = __webpack_public_path__ + "static/media/zadania-powtorkowe-klasa6-powtorkomat-2.01f9483c.jpg";